import { Users } from 'lucide-preact'
import { memo } from 'preact/compat'
import type { DashboardWindowCountDto } from '@/types/dashboard'
import { DashboardStatTile } from './DashboardStatTile'

interface TotalLeadsStatTileProps {
  count: DashboardWindowCountDto | null | undefined
  rangeLabel?: string
  loading?: boolean
  error?: string | null
  failed?: boolean
}

export const TotalLeadsStatTile = memo((props: TotalLeadsStatTileProps) => (
  <DashboardStatTile
    titleLines={['Total Leads', 'Generated']}
    icon={<Users className="w-5 h-5 text-primary-600 dark:text-primary-400" />}
    {...props}
  />
))
